// extracted by mini-css-extract-plugin
export default {"wrapper":"main-action-figure_wrapper__CORAP","left":"main-action-figure_left__DcbMQ","content":"main-action-figure_content__IirLP"};